import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import './MacStyleWindow.css'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'

import closeIcon from '../../../assets/icons/close-icon.svg'
import maximizeIcon from '../../../assets/icons/fullscreen-icon.svg'
import minimizeIcon from '../../../assets/icons/minscreen-icon.svg'

import appStoreIcon from '../../../assets/icons/Documents/app-store-icon.png'
import desktopIcon from '../../../assets/icons/Documents/desktop-icon.png'
import documentsIcon from '../../../assets/icons/Documents/documents-icon.png'

import easestarLogo from '../../../assets/logos/easestar.png'

import PDFIcon from '../../PDFIcon/PDFIcon'
import PDFWindow from '../PDFWindow/PDFWindow'
import FolderIcon from '../../FolderIcon/FolderIcon'

import folderIcon from '../../../assets/icons/Apps/folder-icon.png'
import pdfIcon from '../../../assets/icons/Apps/resume-icon.png'

import { krenzPDFs, getPDFPath } from '../../../config/krenzPDFs'

import AppItemComponent from '../../WindowContent/AppItemComponent/AppItemComponent'
import AppStoreWindowContent from '../../WindowContent/AppStoreWindowContent/AppStoreWindowContent'

import EaseStarInfoComponent from '../../WindowContent/EaseAppsInfoComponent/EaseStarInfoComponent'
import { useOrientation } from '../../../contexts/OrientationContext'

function MacStyleWindow({ onClose, defaultMenu, children }) {
  const { isPortrait } = useOrientation()
  const [isMaximized, setIsMaximized] = useState(false)
  const [selectedMenu, setSelectedMenu] = useState(defaultMenu)
  const [currentContent, setCurrentContent] = useState(null)
  const [openWindow, setOpenWindow] = useState(null)
  const [currentPdf, setCurrentPdf] = useState(null)
  const [appInfoOpen, setAppInfoOpen] = useState(false)
  const [isKrenzFolderOpen, setIsKrenzFolderOpen] = useState(false)
  const [currentKrenzFolder, setCurrentKrenzFolder] = useState(null)

  useEffect(() => {
    setSelectedMenu(defaultMenu) // Ensure the selected menu updates if the default changes
    handleMenuClick(defaultMenu)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultMenu])

  const toggleMaximize = () => {
    setIsMaximized(!isMaximized)
  }

  const handleKrenzFolderClick = () => {
    setIsKrenzFolderOpen(true)
    setAppInfoOpen(true)
    setCurrentKrenzFolder(null)
    const krenzFolders = [
      { name: '基础透视与结构11期', folder: 'perspective-structure-11' },
      { name: '色彩与光影11期', folder: 'color-light-11' },
      { name: '动态与构成10期', folder: 'dynamic-composition-10' },
    ]
    setCurrentContent(
      <div className="macstyle-window-document-container">
        {krenzFolders.map((folder, index) => (
          <div
            key={index}
            onClick={() => handleSubFolderClick(folder.folder)}
            style={{ cursor: 'pointer' }}
          >
            <FolderIcon imageSrc={folderIcon} label={folder.name} />
          </div>
        ))}
      </div>
    )
  }

  const handleSubFolderClick = folderKey => {
    const folderData = krenzPDFs[folderKey]
    if (!folderData) return

    setCurrentKrenzFolder(folderKey)
    setCurrentContent(
      <div className="macstyle-window-document-container">
        {folderData.pdfs.map((pdf, index) => {
          const pdfPath = getPDFPath(folderData.folder, pdf.file)
          return (
            <div key={index} style={{ cursor: 'pointer' }}>
              <PDFIcon
                icon={pdfIcon}
                label={pdf.name}
                pdf={pdfPath}
                onOpen={() => openPDFWindow(pdfPath)}
              />
            </div>
          )
        })}
      </div>
    )
  }

  const handleMenuClick = key => {
    setSelectedMenu(key)
    setIsKrenzFolderOpen(false)
    setCurrentKrenzFolder(null)
    // 根据选中的菜单项设置当前内容
    switch (key) {
      case 'desktop':
        setCurrentContent(
          <div className="macstyle-window-document-container">
            <div onClick={handleKrenzFolderClick} style={{ cursor: 'pointer' }}>
              <FolderIcon imageSrc={folderIcon} label="Krenz绘画笔记" />
            </div>
          </div>
        )
        break
      case 'appStore':
        setCurrentContent(
          <AppStoreWindowContent onAppClick={handleAppStoreClick} />
        )
        break
      case 'documents':
        setCurrentContent(
          <div className="macstyle-window-document-container">
            <div onClick={handleKrenzFolderClick} style={{ cursor: 'pointer' }}>
              <FolderIcon imageSrc={folderIcon} label="Krenz绘画笔记" />
            </div>
          </div>
        )
        break
      default:
        setCurrentContent(null)
    }
  }

  const openPDFWindow = pdf => {
    setCurrentPdf(pdf)
    setOpenWindow('pdf')
  }

  const closePDFWindow = () => {
    setCurrentPdf(null)
    setOpenWindow(null)
  }

  const handleAppStoreClick = title => {
    setAppInfoOpen(true)
    const headerImage = easestarLogo
    setCurrentContent(
      <AppItemComponent headerImage={headerImage}>
        {title === 'EaseStar' && <EaseStarInfoComponent />}
      </AppItemComponent>
    )
  }

  const handleBackClick = () => {
    if (currentKrenzFolder) {
      // 从PDF列表返回到文件夹列表
      setCurrentKrenzFolder(null)
      handleKrenzFolderClick()
    } else if (isKrenzFolderOpen) {
      setIsKrenzFolderOpen(false)
      setAppInfoOpen(false)
      setCurrentKrenzFolder(null)
      // 返回到显示Krenz绘画笔记文件夹
      setCurrentContent(
        <div className="macstyle-window-document-container">
          <div onClick={handleKrenzFolderClick} style={{ cursor: 'pointer' }}>
            <FolderIcon imageSrc={folderIcon} label="Krenz绘画笔记" />
          </div>
        </div>
      )
    } else if (selectedMenu === 'appStore') {
      setAppInfoOpen(false)
      setCurrentContent(
        <AppStoreWindowContent onAppClick={handleAppStoreClick} />
      )
    } else {
      setCurrentContent(null)
    }
  }

  const menuItems = [
    { key: 'desktop', label: 'Desktop', icon: desktopIcon },
    { key: 'appStore', label: 'App Store', icon: appStoreIcon },
    { key: 'documents', label: 'Documents', icon: documentsIcon },
  ]

  // 注意：移动端 documents 视图现在在 DesktopContent 层面处理，这里不再需要检查

  return (
    <div className={`mac-window-overlay ${isPortrait ? 'portrait' : ''}`}>
      <div className={`mac-window ${isMaximized ? 'maximized' : ''}`}>
        <div className="mac-window-sidebar">
          <div className="mac-window-buttons">
            <img
              className="close-icon"
              onClick={onClose}
              src={closeIcon}
              alt="Close"
              style={{ cursor: 'pointer', width: '12px', height: '12px' }}
            />
            <img
              className="close-icon"
              onClick={toggleMaximize}
              src={isMaximized ? minimizeIcon : maximizeIcon}
              alt="Close"
              style={{ cursor: 'pointer', width: '12px', height: '12px' }}
            />
          </div>

          <div className="mac-window-menu">
            {menuItems.map(item => (
              <div
                key={item.key}
                className={`mac-window-menu-item ${
                  selectedMenu === item.key ? 'active' : ''
                }`}
                onClick={() => {
                  handleMenuClick(item.key)
                  setAppInfoOpen(false)
                }}
              >
                <img
                  src={item.icon}
                  alt={`${item.label} Icon`}
                  className="mac-window-menu-icon"
                />
                {item.label}
              </div>
            ))}
          </div>
        </div>
        <div className="mac-window-content">
          <div
            className={`mac-window-content-header ${appInfoOpen || isKrenzFolderOpen ? 'app-info-open' : ''}`}
          >
            {(appInfoOpen || isKrenzFolderOpen || currentKrenzFolder) && (
              <div onClick={handleBackClick} className="back-button">
                <FontAwesomeIcon icon={faChevronLeft} />
              </div>
            )}
            {!appInfoOpen && !isKrenzFolderOpen && !currentKrenzFolder && (
              <div className="mac-window-content-header-title">
                {menuItems.find(item => item.key === selectedMenu)?.label ||
                  'Select a Menu'}
              </div>
            )}
            {isKrenzFolderOpen && !currentKrenzFolder && (
              <div className="mac-window-content-header-title">
                Krenz绘画笔记
              </div>
            )}
            {currentKrenzFolder && (
              <div className="mac-window-content-header-title">
                {krenzPDFs[currentKrenzFolder]?.name || 'Krenz绘画笔记'}
              </div>
            )}
          </div>

          <div className="mac-window-content-body">{currentContent}</div>

          {/* 条件渲染PDF窗口 */}
          {openWindow === 'pdf' && currentPdf && (
            <PDFWindow type="pdf" onClose={closePDFWindow}>
              <iframe
                src={currentPdf}
                title="PDF Viewer"
                style={{ width: '100%', height: '100%', border: 'none' }}
                type="application/pdf"
              />
            </PDFWindow>
          )}
        </div>
      </div>
    </div>
  )
}

MacStyleWindow.propTypes = {
  onClose: PropTypes.func.isRequired,
  defaultMenu: PropTypes.string, // Menu to open by default
  children: PropTypes.node,
}

export default MacStyleWindow
